import Service from '@/helpers/service'

export default {

    get(page, params) {
        return Service().get('AccountCategoryReference?page=' + page, {params});
    }, 
    show(id) {
        return Service().get('AccountCategoryReference/show/'+id);
    },    
    create(params) {
        return Service().post('AccountCategoryReference/create', params);
    },
    update(id, params) {
        return Service().post('AccountCategoryReference/update/'+id, params);
    },
    delete(id) {
        return Service().post('AccountCategoryReference/delete/'+id);
    }
}